<template>
    <el-tooltip :disabled="forceTooltipClose">
        <div
            class="d-flex align-items-center gap-1 pointer"
            @click="handleEventClick(event)">
            <div
                class="fc-daygrid-event-dot"
                :style="'border-color:' + backgroundColor" />
            <span :class="isTooLight(backgroundColor) ? 'darker-text' : 'lighter-text'">{{
                event.title
            }}</span>
        </div>
        <template #content>
            <div
                style="max-width: 300px; z-index: 100"
                class="d-flex flex-column gap-2">
                <h5 class="text-white font-weight-bold mb-0">
                    {{ event.title }}
                </h5>
                <div v-if="event.extendedProps.teaser">
                    <span>{{ event.extendedProps.teaser }}</span>
                </div>
                <div v-if="event.extendedProps.isOnline && event.extendedProps.onlineApplication">
                    <font-awesome-icon icon="globe" />
                    <strong>
                        {{ event.extendedProps.onlineApplication }}
                    </strong>
                </div>
                <div class="d-flex align-items-center mt-1">
                    <font-awesome-icon
                        class="mr-2"
                        icon="calendar-alt" />
                    <span v-if="!!event.extendedProps.all_day">
                        <span
                            v-if="$moment(event.start).isSame($moment(event.end).subtract(1, 'day'), 'day')">
                            {{ $d(event.start, 'dateNumeric') }}
                        </span>
                        <span v-else>
                            {{ $d(event.start, 'dateNumeric') }} -
                            {{ $df($moment(event.end).subtract(1, 'day'), 'dateNumeric') }}
                        </span>
                    </span>
                    <span v-else>
                        <span
                            v-if="$moment(event.start).isSame($moment(event.end), 'day')">
                            {{ $d(event.start, 'dateNumeric') }},
                            <span v-if="event.extendedProps.openEnd">
                                ab {{ $d(event.start, 'time') }}
                            </span>
                            <span v-else>
                                {{ $d(event.start, 'time') }} -
                                {{ $d(event.end, 'time') }}
                            </span>
                        </span>
                        <span v-else>
                            {{ $d(event.start, 'dateTimeNumeric') }}
                            -
                            {{ $d(event.end, 'dateTimeNumeric') }}
                        </span>
                    </span>
                </div>
            </div>
        </template>
    </el-tooltip>
</template>

<script>
export default {
    name: "CalendarEventContent",
    props: {
        backgroundColor: {default: null},
        event: {default: null},
        forceTooltipClose: {type: Boolean, default: false}
    },
    methods: {
        handleEventClick(event) {
            if (event && this.calendarApi) {
                this.calendarApi.gotoDate(event.start)
            }
            this.$emit('open', {id: event?.id})
        },
        isTooLight(color) {
            // #c4f0fb
            const m = color.substr(1).match(color.length == 7 ? /(\S{2})/g : /(\S{1})/g);
            if (!m) return false
            const r = parseInt(m[0], 16), g = parseInt(m[1], 16), b = parseInt(m[2], 16);
            if (!r || !g || !b) return false
            return ((r * 299) + (g * 587) + (b * 114)) / 1000 > 200;
        }
    }
}
</script>

<style scoped>

</style>
